import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

import configurationStore from '../stores/configuration-store';

import Wizard from './wizard';

const l = configurationStore.getLocalization.bind(configurationStore);
const ID = 'menu';


export default createReactClass({
	displayName: 'ProductWizardMenu',
	lastItemCount: null,
	lastAccessoryCount: null,

	propTypes: {
		onSelectProperty: PropTypes.func,
		itemCount: PropTypes.number,
		accessoryCount: PropTypes.number,
		selected: PropTypes.string,
		region: PropTypes.bool
	},

	getDefaultProps() {
		return {
			itemCount: 0,
			accessoryCount: 0,
			selected: 'assistant',
			region: 'int'
		};
	},

	onSelectProperty(facet, property) {
		if (property.id !== this.props.selected) {
			this.props.onSelectProperty(property.id);
		}
	},

	render() {
		const facet = {
			id: ID,
			properties: [],
			selectedProperty: this.props.selected
		};

		const items = [];

		items.push(
			{
				id: 'assistant',
				labelKEY: 'title',
				countKEY: null
			}
		);
		if (this.props.region !== 'usa' && this.props.region !== 'can') {
			items.push(
				{
					id: 'resultsItem',
					labelKEY: 'resultsItemTitle',
					countKEY: 'itemCount'
				}
			);
			items.push(
				{
					id: 'resultsAccessory',
					labelKEY: 'resultsAccessoryTitle',
					countKEY: 'accessoryCount'
				}
			);
		}

		items.forEach((item) => {
			let prop = {
				id: item.id,
				label: l(item.labelKEY),
				isCollapsed: false,
				isDisabled: item.countKEY ? this.props[item.countKEY] <= 0 : false,
				isSelected: this.props.selected === item.id,
				isDeselectable: false,
				isQuasiSelected: false,
				preselectionItemCount: item.countKEY ? this.props[item.countKEY] : null,
				modificators: ['menu', item.id]
			};
			if (item.id === 'resultsItem') {
				prop.highlight = this.lastItemCount !== this.props.itemCount;
			} else if (item.id === 'resultsAccessory') {
				prop.highlight = this.lastAccessoryCount !== this.props.accessoryCount;
			}
			facet.properties.push(prop);
		});

		facet.selectableProperties = facet.properties;

		this.lastItemCount = this.props.itemCount;
		this.lastAccessoryCount = this.props.accessoryCount;

		const attributes = {
			id: ID,
			title: null,
			facets: [facet],
			hideTitle: true,
			inlineFacets: true,
			slider: false,
			active: true,
			onPropertyChange: this.onPropertyChange,
			isAccessory: false,
			isFlapable: false,
			onSelectProperty: this.onSelectProperty,
			showPreselectionItemCount: true,
			topBorder: false
		};

		return (
			<Wizard {...attributes} />
		);
	}
});
